import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";

function ServiceCaseSparePartForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
            <StringInput name={'Objednavaci_Kod'} label={'Objednávací Kód'} value={data.Objednavaci_Kod} onChange={update}/>
            <StringInput name={'Cena'} label={'Cena'} value={data.Cena} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Náhradný diel"
                     labelNew="Pridať Náhradný diel"
                     baseUrl='/service_case/service_cases_spare_parts/'
                     formContent={formContent}/>
    )
}

export default ServiceCaseSparePartForm
